import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=ddc58a16&scoped=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=js"
export * from "./PerformanceChart.vue?vue&type=script&lang=js"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=ddc58a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc58a16",
  null
  
)

export default component.exports